import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpPopoutComponent } from './components/help-popout/help-popout.component';
import { RouterModule } from '@angular/router';
import { SubjectTopicLinkButtonComponent } from './components/subject-topic-link-button/subject-topic-link-button.component';
import { DontSanitizeHtmlPipe, MonoCommonModule } from '@nx/mono-common';
import { SecondaryPageCtaPanelComponent } from './components/secondary-page-cta-panel/secondary-page-cta-panel.component';
import { CalloutComponent } from '@nx/mono-common/lib/components/callout/callout.component';
import { HelpPopupComponent } from '@nx/mono-common/lib/components/help-popup/help-popup.component';
import { ShowHidePasswordToggleComponent } from '@nx/mono-common/lib/components/show-hide-password-toggle/show-hide-password-toggle.component';
import { PasswordHelpPopupComponent } from '@nx/mono-common/lib/components/password-help-popup/password-help-popup.component';



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CalloutComponent,
    HelpPopupComponent,
    ShowHidePasswordToggleComponent,
    PasswordHelpPopupComponent,
    DontSanitizeHtmlPipe
  ],
  declarations: [
    HelpPopoutComponent,
    SubjectTopicLinkButtonComponent,
    SecondaryPageCtaPanelComponent,
  ],
  exports: [
    HelpPopoutComponent,
    SubjectTopicLinkButtonComponent,
    MonoCommonModule,
    SecondaryPageCtaPanelComponent,
    CalloutComponent,
    HelpPopupComponent,
    ShowHidePasswordToggleComponent,
    PasswordHelpPopupComponent,
    DontSanitizeHtmlPipe
  ]
})
export class LmwCommonModule {

}
